import React, { useEffect, useState } from "react";
import { FaSliders} from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import "./css/Mensajes.css";

const Mensajes = () => {
  
  return (
    <>
        <Navbar />
        
        <main className="agenda">

        </main>
    </>
  );
};

export default Mensajes;